import { render, staticRenderFns } from "./ItemClasses.vue?vue&type=template&id=be738d66&scoped=true"
import script from "./ItemClasses.vue?vue&type=script&lang=js"
export * from "./ItemClasses.vue?vue&type=script&lang=js"
import style0 from "./ItemClasses.vue?vue&type=style&index=0&id=be738d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be738d66",
  null
  
)

export default component.exports